export const REFER_AMOUNT = '$10'; // in the future this might be dynamic
